import { Col, Layout, Row } from "antd";

import IntlMessages from "../../../layout/components/lang/IntlMessages";

export default function MenuFooter() {
  const { Footer } = Layout;
  
  return (
    <Footer className="">
      <Row align="middle" justify="space-between">
        <Col md={12} span={24}>
          <p className="hp-badge-text hp-font-weight-600 hp-mb-0 hp-text-color-dark-30">
            <IntlMessages id="footer-copyright" /> ©2021 Allnube, <IntlMessages id="footer-all-rights-reserved" />     
          </p>
        </Col>
      </Row>
    </Footer>
  );
};